import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './api'; // configura le chiamate al server (token, sessione scaduta)
import { avvia as avviaMonitoraggio } from './monitoraggio';
import reportWebVitals from './reportWebVitals';

// Segnalazione degli errori, se configurata: va avviata prima che l'app parta.
avviaMonitoraggio();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
